import { Component, Input, OnDestroy } from '@angular/core';
import {
  InspectionRiskLevelsCase,
  RiskLevelDto,
  TextBank
} from '@authority-labs/api-interfaces';
import { nameof } from '@authority-labs/helpers';
import { ChangeType } from '@check-list/app/classes/enums';
import { TextBankService } from '@check-list/app/shared';
import { NotesBankDialogService } from '@check-list/app/shared/dialogs/notes-bank-dialog/notes-bank-dialog.service';
import { RequestQueryBuilder } from '@nestjsx/crud-request';
import { Observable, Subject } from 'rxjs';
import { filter, shareReplay, takeUntil } from 'rxjs/operators';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

const PATH = 'text-bank';

@Component({
  selector: 'authority-labs-check-risk-levels-case',
  templateUrl: './check-risk-levels-case.component.html',
  styleUrls: ['./check-risk-levels-case.component.scss']
})
export class CheckRiskLevelsCaseComponent
  extends CheckBasicCaseComponent
  implements OnDestroy
{
  @Input() inspection: InspectionRiskLevelsCase;

  displayedColumns = ['riskLevel', 'select', 'installationArea'];

  filteredOptions: Observable<string[]>;
  installationAreas: string[];
  filteredInstallationAreas: string[];
  editableNoteIndex: number | null = null;
  qb: RequestQueryBuilder;
  type = 'installationArea';

  private componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    private readonly notesBankDialogService: NotesBankDialogService,
    private readonly textBankService: TextBankService
  ) {
    super();

    this.qb = RequestQueryBuilder.create();
    this.qb.search({
      [nameof<TextBank>('type')]: {
        $eq: this.type
      }
    });

    TextBankService.changesEmitter
      .pipe(
        takeUntil(this.componentDestroyed$),
        filter(
          (event) =>
            event.path === PATH && event.queryParams === this.qb.query()
        )
      )
      .subscribe((event) => {
        if (
          [ChangeType.deleted, ChangeType.edited, ChangeType.created].includes(
            event.action
          )
        ) {
          this.loadInstallationAreasOptions();
        }
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  onFocus(): void {
    if (!this.installationAreas) {
      this.loadInstallationAreasOptions();
    }
  }

  showNotesBank(e: Event, riskLevel: RiskLevelDto) {
    e.stopPropagation();
    this.notesBankDialogService
      .showMulti(this.type)
      .afterClosed()
      .pipe(filter((content) => !!content))
      .subscribe((content) => {
        if (Array.isArray(content)) {
          riskLevel.installationArea = content.join('\r\n');
        } else {
          riskLevel.installationArea = content;
        }
        this.onChange();
      });
  }

  onInstallationAreaChange(value: string): void {
    this.filter(value);
    this.onChange();
  }

  private filter(value: string): void {
    const filterValue = value.toLowerCase();

    this.filteredInstallationAreas = this.installationAreas.filter((x) =>
      x.toLowerCase().includes(filterValue)
    );
  }

  private loadInstallationAreasOptions(): void {
    this.textBankService
      .getAll(this.qb)
      .pipe(shareReplay(1))
      .subscribe((resp) => {
        this.installationAreas = resp.map((item) => item.content);
      });
  }
}
